import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./../styles/ecom.css";
import "./../styles/ecom/comprar.css";
import NavbarTop from "./ecom/Navbartop";
import Footer from "./ecom/Footer";
import * as globals from "./../components/GlobalScripts.js";

const Checkout = () => {
    const path_api = localStorage.getItem("path_api");
    const [cargoStripe, setCargoStripe] = useState(false);
    const [carrito, setCarrito] = useState([]);
    const [envioGratis, setEnvioGratis] = useState(false);
    const [total_pago, setTotal_pago] = useState(0);
    const [divisa_pago, setDivisa_pago] = useState('MXN');
    const [formData, setFormData] = useState({
        email: "",
        nombre: "",
        direccion: "",
        referencia: "",
        apartamento: "",
        pais: "México",
        estado: "",
        ciudad: "",
        colonia: "",
        codigoPostal: "",
        telefono: "",
        divisa: "MXN",
    });

    useEffect(() => {
        const fetchFacebookData = async () => {
            let facebookParams = globals.facebookParams();
            let event_source_url = facebookParams.event_source_url;
            let client_user_agent = facebookParams.client_user_agent;
            let event_time = facebookParams.event_time;
            let facebookPixel = facebookParams.facebookPixel;
            let facebookToken = facebookParams.facebookToken;
            let event_id = facebookParams.event_id;

            let data = {
                "event_source_url": event_source_url,
                "event_time": event_time,
                "client_user_agent": client_user_agent,
                "hostedBy": "Zadrig"
            };

            await window.fbq('track', 'PageView', data, { eventID: event_id });

            let fbp = facebookParams.fbp;
            let fbc = facebookParams.fbc;

            await fetch('https://zadrig.com/facebook/eventos/ecommerce.zadrigman/pageview.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    event_id: event_id,
                    facebookPixel: facebookPixel,
                    facebookToken: facebookToken,
                    event_time: event_time,
                    fbp: fbp,
                    fbc: fbc,
                    event_source_url: event_source_url,
                    client_user_agent: client_user_agent
                }),
            });
        };

        fetchFacebookData();
    }, []);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/";
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            initializeStripe();
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const initializeStripe = async () => {
        await axios
            .post(`${path_api}/ecom/get_stripe_keys.php`, {
                rute: globals.getRuteBackend()
            })
            .then((response) => {
                if (response.data.mensaje === "success") {
                    if (!window.stripe)
                        window.stripe = window.Stripe(response.data.key_public);
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Stripe",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                }
            })
            .catch((error) => {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-stripe-1'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
            });
    };

    const initiate_checkout_fb = async (total_fb, divisa_fb) => {
        let facebookParams = globals.facebookParams();
        let event_source_url = facebookParams.event_source_url;
        let client_user_agent = facebookParams.client_user_agent;
        let event_time = facebookParams.event_time;
        let facebookPixel = facebookParams.facebookPixel;
        let facebookToken = facebookParams.facebookToken;
        let event_id = facebookParams.event_id;

        let data = {
            "event_source_url": event_source_url,
            "event_time": event_time,
            "client_user_agent": client_user_agent,
            "content_name": 'carrito',
            "value": total_fb,
            "currency": divisa_fb,
            "hostedBy": "Zadrig"
        };

        await window.fbq('track', 'InitiateCheckout', data, { eventID: event_id });
        
        let fbp = facebookParams.fbp;
        let fbc = facebookParams.fbc;

        await fetch('https://zadrig.com/facebook/eventos/ecommerce.zadrigman/initiate_checkout.php', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                event_id: event_id,
                facebookPixel: facebookPixel,
                facebookToken: facebookToken,
                event_time: event_time,
                fbp: fbp,
                fbc: fbc,
                event_source_url: event_source_url,
                client_user_agent: client_user_agent,
                producto: 'carrito',
                precio: total_fb,
                divisa: divisa_fb,
            }),
        });
    };

    const chargeStripe = async () => {
        if (!formData.nombre || !formData.email || !formData.divisa) {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Llena los campos",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000,
            });
            return;
        }

        globals.openViewCharge();
        await axios
            .post(`${path_api}/stripe/create.php`, {
                rute: globals.getRuteBackend(),
                name: formData.nombre,
                email: formData.email,
                divisa: formData.divisa,
                envio_all: formData,
                carrito: carrito
            })
            .then(async (response) => {
                if (response.data.mensaje === "success") {

                    setCargoStripe(true);

                    const intervalId = setInterval(async () => {
                        const paymentElement = document.querySelector('#payment-element');
                        if (paymentElement) {
                            await setTotal_pago(response.data.total);
                            await setDivisa_pago(response.data.divisa);
                            initiate_checkout_fb(response.data.total, response.data.divisa);
                            window.clientSecret = response.data.response.client_secret;

                            window.elements = window.stripe.elements({ clientSecret: window.clientSecret });

                            await window.elements.create("payment", { layout: "tabs" }).mount("#payment-element");

                            globals.closeViewCharge();

                            clearInterval(intervalId);
                        }
                    }, 1000);

                } else if (response.data.mensaje === "cambio") {
                    localStorage.setItem("carrito", JSON.stringify(response.data.carrito));

                    setCarrito(response.data.carrito);
                    verificarEnvioGratis(response.data.carrito);

                    globals.createAlert({
                        type: "advertencia",
                        msg_title: "Cambios en carrito",
                        msg: "Se realizaron cambios en tu carrito.",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                    globals.closeViewCharge();
                } else {
                    globals.createAlert({
                        type: "error",
                        msg_title: "Error",
                        msg: response.data.mensaje || "Sin comunicación con Stripe",
                        effect: "opacidad 2s, desplazamiento 2s",
                        time_life: 4000,
                    });
                    globals.closeViewCharge();
                }
            })
            .catch((error) => {

                console.log(error)
                globals.createAlert({
                    type: "error",
                    msg_title: "Error 'log-stripe-2'",
                    msg: "Si persiste informa al soporte",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000,
                });
                globals.closeViewCharge();
            });
    };

    useEffect(() => {
        setCargoStripe(false);
    }, [formData.nombre, formData.email, formData.divisa]);

    useEffect(() => {
        const carritoData = JSON.parse(localStorage.getItem("carrito")) || [];
        setCarrito(carritoData);
        verificarEnvioGratis(carritoData);
    }, []);

    const verificarEnvioGratis = (carrito) => {
        const total = carrito.reduce((acc, item) => acc + item.precio * item.cantidad, 0);
        const tieneEnvioGratis = carrito.some((item) => item.envio === "gratis");
        if (tieneEnvioGratis || total >= 2000) {
            setEnvioGratis(true);
        } else {
            setEnvioGratis(false);
        }
    };

    const total = carrito.reduce((acc, item) => acc + item.precio * item.cantidad, 0);
    const costoEnvio = envioGratis ? 0 : 200;
    const totalConEnvio = total + costoEnvio;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        globals.openViewCharge();

        let redirect = globals.getRuteTY();
        let url = `https://ecommerce.zadrigman.com/backend/stripe/confirm/?redirect=${encodeURIComponent(redirect)}`;
        await window.stripe.confirmPayment({
            elements: window.elements,
            confirmParams: {
                return_url: url,
            },
        }).then(function (result) {
            if (result.error) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: result.error.message, effect: "opacidad 2s, desplazamiento 2s", time_life: 6000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "Error interno, intenta más tarde", effect: "opacidad 2s, desplazamiento 2s", time_life: 8000 });
            }
            globals.closeViewCharge();
        });
    };

    return (
        <div className="app-ecom app-container">
            <NavbarTop />
            <div className="main-content page-comprar">
                <div className="page-container">
                    <div className="container-section flex-column margin-top">
                        <div className="checkout-grid">
                            <div className="checkout-form">
                                <form onSubmit={handleSubmit}>
                                    <h2>Contacto</h2>

                                    <div className="form-group">
                                        <label htmlFor="nombre">Nombre</label>
                                        <input
                                            type="text"
                                            id="nombre"
                                            name="nombre"
                                            value={formData.nombre}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="email">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <h2>Envio</h2>

                                    <div className="form-group">
                                        <label htmlFor="direccion">Dirección</label>
                                        <input
                                            type="text"
                                            id="direccion"
                                            name="direccion"
                                            value={formData.direccion}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="referencia">Referencia</label>
                                        <input
                                            type="text"
                                            id="referencia"
                                            name="referencia"
                                            value={formData.referencia}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="apartamento">Apartamento</label>
                                        <input
                                            type="text"
                                            id="apartamento"
                                            name="apartamento"
                                            value={formData.apartamento}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="pais">País</label>
                                        <select
                                            id="pais"
                                            name="pais"
                                            value={formData.pais}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="México">México</option>
                                            <option value="Otro">Otro</option>
                                        </select>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="estado">Estado</label>
                                        <input
                                            type="text"
                                            id="estado"
                                            name="estado"
                                            value={formData.estado}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="ciudad">Ciudad</label>
                                        <input
                                            type="text"
                                            id="ciudad"
                                            name="ciudad"
                                            value={formData.ciudad}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="colonia">Colonia</label>
                                        <input
                                            type="text"
                                            id="colonia"
                                            name="colonia"
                                            value={formData.colonia}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="codigoPostal">Código Postal</label>
                                        <input
                                            type="text"
                                            id="codigoPostal"
                                            name="codigoPostal"
                                            value={formData.codigoPostal}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="telefono">Teléfono</label>
                                        <input
                                            type="text"
                                            id="telefono"
                                            name="telefono"
                                            value={formData.telefono}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="divisa">Divisa</label>
                                        <select
                                            id="divisa"
                                            name="divisa"
                                            value={formData.divisa}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="USD">USD</option>
                                            <option value="MXN">MXN</option>
                                            <option value="EUR">EUR</option>
                                            <option value="COP">COP</option>
                                            <option value="CLP">CLP</option>
                                        </select>
                                    </div>

                                    <div id="stripe-container">
                                        {cargoStripe && (
                                            <div id="payment-element"></div>
                                        )}
                                        {formData.pais === "México" && !cargoStripe && (
                                            <span onClick={chargeStripe} className="button-primary green button-desk">
                                                Pagar ahora
                                            </span>
                                        )}
                                    </div>

                                    {formData.pais === "México" && cargoStripe && (
                                        <button type="submit" className="button-primary green button-desk">
                                            Finalizar compra ({total_pago} {divisa_pago})
                                        </button>
                                    )}
                                </form>
                            </div>

                            <div className="checkout-summary">
                                <div className="cart-items-summary">
                                    {carrito.map((item, index) => (
                                        <div className="summary-item" key={index}>
                                            <img src={item.imagen} alt={item.nombre} />
                                            <div>
                                                <h4>{item.nombre}</h4>
                                                <p>{item.color} / {item.talla}</p>
                                                <p>Cantidad: {item.cantidad}</p>
                                                <h5>${(item.precio * item.cantidad).toFixed(2)} MXN</h5>
                                            </div>
                                        </div>
                                    ))}

                                    <div className="order-summary">
                                        <p>Subtotal: ${total.toFixed(2)} MXN</p>
                                        {formData.pais === "México" ? (
                                            <p>Envío: {envioGratis ? "Gratis" : `$${costoEnvio.toFixed(2)} MXN`}</p>
                                        ) : (
                                            <p style={{ color: "var(--color-red)" }}>
                                                Los envíos internacionales tienen un precio de envío diferente. Contáctanos.
                                            </p>
                                        )}
                                        <h3>Total: ${formData.pais === "México" ? totalConEnvio.toFixed(2) : total.toFixed(2)} MXN</h3>
                                        {formData.pais === "México" && !cargoStripe && (
                                            <span onClick={chargeStripe} className="button-primary green button-mobile">
                                                Pagar ahora
                                            </span>
                                        )}
                                        {formData.pais === "México" && cargoStripe && (
                                            <button
                                                onClick={() => document.querySelector('.button-desk')?.click()}
                                                className="button-primary green button-mobile"
                                            >
                                                Finalizar compra ({total_pago} {divisa_pago})
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Checkout;
